import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@walmart-web/livingdesign-components';

import { useAppSelector } from '../../../../redux/hooks.ts';
import { ihutSelectors } from '../../../../redux/slices/ihut.ts';

const DoneButton = () => {
  const { t } = useTranslation('common');
  const activity = useAppSelector(ihutSelectors.selectSelectedActivity);

  if (!activity?.isFeedbackSurveyTaken) return null;

  return (
    <Link to="/activities" style={{ width: '200px', textDecoration: 'none' }}>
      <Button variant="primary" size="small" isFullWidth>
        {t('done')}
      </Button>
    </Link>
  );
};

export default DoneButton;
